import React, { Component } from "react";
import BreadCumb from "./../component/Department/BreadCumb";
import BreadCrumbOwn from "../component/Essentials/BreadCrumbOwn";
import { Grid, Container, Typography } from "@material-ui/core";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter"; // Use for X
import { IconButton } from "@material-ui/core";

export default class ContactUsContainer extends Component {
  render() {
    return (
      <div>

        <BreadCrumbOwn title="Contact Us" />
        <Container style={{ minHeight: '600px' }}>
          <br></br>
          <div>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <ul>
                  <li style={{ paddingBottom: "", listStyle: 'none', fontSize: '1em', marginLeft: "-40px" }}>
                    <Typography variant="h5" style={{ margin: "1em 0", fontWeight: 700 }} gutterBottom>
                      Postal Address:
                    </Typography>
                    <Typography variant="body1" style={{ lineHeight: "1em" }}>
                      Office of the Programme Officer
                      <br />
                      National Service Scheme (NSS) Unit,
                      <br />
                      Dispur College, Ganeshguri, Guwahati, 
                      <br/>
                      Kamrup (Metropolitan), Assam, India
                      <br />
                      Pin : 781006
                      <br />
                      Email:{"nssdispurcollege01@gmail.com, po.nss.dispurcollege@gmail.com "}
                      <a href={`nssdispurcollege01@gmail.com, po.nss.dispurcollege@gmail.com`}>
                      
                      </a>
                      {/* <br/>
                      <a href={`po.nss.dispurcollege@gmail.com`}>
                      
                      </a> */}
                      <br />
                      {/* Webmail:{" "}
                      <a href={`mailto:principal.eraligool@gmail.com`}>
                      
                      </a>
                      
                      <br /> */}
                      Phnone: 9957903913
                      <br />
                      Website:{" "}
                      <a href={`https://dispurcollege.ac.in/`}>
                        https://dispurcollege.ac.in/
                      </a>{" "}
                      <br />
                      
                    </Typography>
                    
<Typography variant="h6" style={{ marginTop: "1em" }}>
  Follow Us:
</Typography>

<IconButton
  component="a"
  href="https://www.facebook.com/profile.php?id=61583598451798"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Facebook"
>
  <FacebookIcon style={{color:"#1877F2"}}fontSize="large" />
</IconButton>

<IconButton
  component="a"
  href="https://www.instagram.com/nss_dispur_college?igsh=b3FoNXY0MWhsZmY1"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Instagram"
>
  <InstagramIcon style={{color:"#E1306C"}} fontSize="large" />
</IconButton>

<IconButton
  component="a"
  href="https://twitter.com/@NSS_Dispur_Clg"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="X"
>
  <TwitterIcon style={{color:"#000000"}} fontSize="large" />
</IconButton>
                  </li>
                </ul>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.4641484306544!2d91.78450509999999!3d26.149009199999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375a5922a0100723%3A0x48c22d59955cd557!2sDispur%20College!5e0!3m2!1sen!2sin!4v1765972145229!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                  width="600"
                  height="400"
                  style={{ border: 0, maxWidth: '100%' }}
                  allowfullscreen=""
                  loading="lazy"
                ></iframe>

              </Grid>
            </Grid>

          </div>
        </Container>
      </div>
    );
  }
}
